import './style.css';

import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

@inject('vm')
@observer
class Badge extends React.Component {
  render() {
    if (!this.show) return null;
    return <div className={this.className}>{this.label}</div>;
  }

  @computed
  get show() {
    let { status, report } = this.props.vm;
    return status === 'normal' && !!report;
  }

  @computed
  get label() {
    let { status } = this.props.vm.report;
    switch (status) {
      case 0:
        return 'Draft';
      case 1:
        return 'Submitted';
      case 2:
        return 'Accepted';
      case 3:
        return 'Rejected';
      case 4:
        return 'Acknowleged';
      case 5:
        return 'Queried';
      case 6:
        return 'Queried'; //resubmitted state
    }
  }

  @computed
  get className() {
    const { status } = this.props.vm.report;
    const resubmitted = status === 6 ? 'resubmitted' : '';
    return `statusLabel ${this.label.toLowerCase()} ${resubmitted}`;
  }
}

export default Badge;
